import React, { useEffect } from 'react';
import { useFlightTypeContext } from 'src/contexts/flight-type.context';
import { actionTypes } from 'src/ducks/flight-type.duck';
import { getFlightTypeStatus } from 'src/selectors/flight-type.selector';
import FlightTypeView from './flight-types-list.view';

const FlightTypes: React.FC = () => {
  const { state, actions } = useFlightTypeContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <FlightTypeView
      loading={
        getFlightTypeStatus(state, actionTypes.FLIGHT_TYPE_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default FlightTypes;
